<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="mobile-button-container">
      <div class="mobile-button hide">
        <main-button depressed @click="goTo(routes.organizer.newWorkshop)">
          Create workshop
        </main-button>
      </div>
      <v-layout wrap>
        <v-flex class="title-screen" xs12>
          <span>Workshops</span>
        </v-flex>
        <v-flex>
          <div class="mb-32 title-description">
            You can add or edit workshops hosted at your event. You can also track current
            attendance quota uptake and manage attendees for every workshop.
          </div>
        </v-flex>
        <v-flex class="pb-16" xs12>
          <main-button class="desktop-button" depressed @click="goTo(routes.organizer.newWorkshop)">
            Create workshop
          </main-button>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="workshops"
            item-clickable
            :headers="[
              { text: 'Name', align: 'left', value: 'name' },
              { text: 'Attendance limit', align: 'left', value: 'attendanceLimit' },
              { text: 'Start date', align: 'left', value: 'from' },
              { text: 'End date', align: 'left', value: 'to' },
            ]"
            @item-click="
              goTo(routes.organizer.updateWorkshop, {
                eventId: eventId,
                workshopId: $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_EVENT_WORKSHOPS } from '../../graphql/workshop.graphql.js'
import { formatDate } from '../../utils'

export default {
  name: 'workshop-list-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  apollo: {
    getEventWorkshops: {
      query: GET_EVENT_WORKSHOPS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getWorkshops: workshops } = data
          this.workshops = workshops.map(w => {
            return {
              ...w,
              to: formatDate(w.to),
              from: formatDate(w.from),
              attendanceLimit: w.unlimitedAttendance ? 'Unlimited' : w.attendanceLimit,
            }
          })
        }
      },
    },
  },
}
</script>

<style></style>
